import TestService from '../services/test.service';

export const test = {
  namespaced: true,
  state: {
    testList: [],
    //newTest:''
  },
  actions: {
    async getTestList({ commit }) {
      const resp = await TestService.getTestList();
      if (resp.status === 200) {
        commit('SET_TEST_LIST', resp.data);
      } 
      return resp.status;
    },

    async getTest(_, testeId){
      const resp = await TestService.getTest(testeId);
      return resp.data
    },

    async createTest(_, newTest) {
      const resp = await TestService.createTest(newTest);
      return resp;
    },
    async deleteTest(_, testeId) {
      const resp = await TestService.deleteTest(testeId);
      return resp.status;
    },
    async updateTest(_, test) {
      const resp = await TestService.updateTest(test);
      return resp;
    }
  },
  mutations: {
    SET_TEST_LIST(state, testList) {
      // testList.forEach(item => {
      //   item.dataCriacao = item.dataCriacao.substring(8,10) + "/" + item.dataCriacao.substring(5,7) + '/' + item.dataCriacao.substring(0,4) + ' ' + item.dataCriacao.substring(11,16) 
      // });
      state.testList = testList;
    }
  },
};
